import { ReactNode } from 'react';
import { Grid } from '@/common/components/Grid/Grid';

export type TPocketCardsGridProps = {
  children: ReactNode;
};

export function PocketCardsGrid({ children }: TPocketCardsGridProps) {
  return (
    <Grid columnBasis="basis-[27rem]" gap="section">
      {children}
    </Grid>
  );
}
